import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const targetAccountsBaseUrl = apiClient.REACT_APP_API_TARGET_ACCOUNT_BASE_URL;
const linkedinApiBaseUrl = apiClient.REACT_APP_API_BASE_URL;
const companiesBaseUrl = apiClient.REACT_APP_COMPANIES_API_BASE_URL;

export function postImpactedCompanies(request) {
    const impactedUrl = joinUrlWithRoute(linkedinApiBaseUrl, "/impacted-companies");

    return apiClient.post(impactedUrl, request);
}

export function postCompaniesLogos(request) {
    const logosUrl = joinUrlWithRoute(companiesBaseUrl, "/logos");

    return apiClient.post(logosUrl, request);
}

export function postTargetAccounts(request, { signal } = {}) {
    const url = joinUrlWithRoute(targetAccountsBaseUrl, "/");
    return apiClient
        .getWithParams(url, request, signal ? { signal } : {})
        .then((response) => response?.data ?? response);
}

export function postConfiguration() {
    return apiClient.get(targetAccountsBaseUrl);
}
